import { ErrorState } from "@leagueplatform/web-common-components";
import { Box, useMediaQuery, queryHelpers } from "@leagueplatform/genesis-core";
import { CenteredLayout } from "components/centered-layout/centered-layout.component";
import { useIntl } from "@leagueplatform/locales";
import ERROR from "assets/error.svg";

interface GenericErrorProps {
  bodyString?: string;
}

export const GenericError = ({ bodyString }: GenericErrorProps) => {
  const { formatMessage } = useIntl();
  const isMobile = useMediaQuery(queryHelpers.down("tablet"));

  return (
    <CenteredLayout>
      <Box css={{ padding: isMobile ? "$oneAndHalf" : "$twoAndHalf" }}>
        <ErrorState
          headingString={formatMessage({
            id: "STR_ERROR_STATE_HEADING_GENERIC",
          })}
          bodyString={
            bodyString ?? formatMessage({ id: "STR_ERROR_STATE_BODY_API" })
          }
          error={null}
          buttonText={formatMessage({ id: "STR_RELOAD" })}
          imageSrc={ERROR}
          css={{
            marginBlockStart: "$one",
            ".error-state-button-wrapper": {
              display: "block",
              width: "100%",
            },
            ".error-state-button": {
              width: 328,
              maxWidth: "100%",
              justifyContent: "center",
            },
            ".error-state-body-text": {
              color: "$onSurfaceTextSubdued",
            },
          }}
        />
      </Box>
    </CenteredLayout>
  );
};
